import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AddLibraryItemRequest } from '@kreart/shared';
import { libraryApi } from './api';
import { LIBRARY_FEATURE_ENABLED } from './featureFlags';

const ROOT = ['library'] as const;
export const libraryQueryKeys = {
  all: ROOT,
  list: () => [...ROOT, 'list'] as const,
};

interface UseLibraryOptions {
  enabled?: boolean;
}

export function useLibrary({ enabled = LIBRARY_FEATURE_ENABLED }: UseLibraryOptions = {}) {
  return useQuery({
    queryKey: libraryQueryKeys.list(),
    queryFn: () => libraryApi.list(),
    enabled,
    meta: { silent: true },
  });
}

export function useAddLibraryItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: AddLibraryItemRequest) => libraryApi.add(body),
    meta: { silent: true },
    onSuccess: () => qc.invalidateQueries({ queryKey: libraryQueryKeys.list() }),
  });
}

export function useRemoveLibraryItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (catalogItemId: string) => libraryApi.remove(catalogItemId),
    meta: { silent: true },
    onSuccess: () => qc.invalidateQueries({ queryKey: libraryQueryKeys.list() }),
  });
}
